<template>
  <div>
    <v-row>
      <v-col>
        <h2>
          Edit User
        </h2>
      </v-col>
    </v-row>
    <user :id="$route.params.id" />
  </div>
</template>

<script>
import User from '../../_components/User';

export default {
  name: 'EditUser',
  components: {
    User,
  },
};
</script>
